import { useState } from "react";
import { Link, useLocation } from "react-router-dom";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  // Navigation items with routes and sections
  const NAV = [
    { path: "/", label: "Acasă", section: "home" },
    { path: "/", label: "Servicii", section: "servicii" },
    { path: "/", label: "Galerie", section: "galerie" },
    { path: "/instalatii", label: "Instalații", section: null },
    { path: "/contact", label: "Contact", section: null },
  ];

  const handleNavClick = (item) => (e) => {
    if (item.section && location.pathname === "/") {
      // Same page, scroll to section
      e.preventDefault();
      const el = document.getElementById(item.section);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
      window.history.replaceState(null, "", window.location.pathname + window.location.search);
    }
    setOpen(false);
  };

  return (
    <header className="sticky top-0 z-50 border-b bg-white/80 backdrop-blur supports-[backdrop-filter]:bg-white/60">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3">
        {/* Logo / Brand */}
        <Link
          to="/"
          aria-label="Instalații Sanitare Marius Pocei"
          className="inline-flex items-center gap-3"
        >
          <img
            src="/logo.png"
            alt="Instalații Sanitare Marius Pocei"
            className="h-12 w-auto select-none md:h-14 lg:h-16"
            draggable="false"
          />
          <span className="text-xs font-semibold leading-tight text-slate-800 sm:text-sm">
            Marius Pocei
            <span className="hidden text-[11px] font-normal text-slate-500 sm:block">Instalații Sanitare · Arad</span>
          </span>
        </Link>

        {/* Desktop nav */}
        <div className="hidden items-center gap-6 md:flex">
          <nav className="flex items-center gap-4 text-sm">
            {NAV.map((item) => (
              <Link
                key={item.label}
                to={item.path}
                onClick={handleNavClick(item)}
                className="hover:text-slate-700"
              >
                {item.label}
              </Link>
            ))}
          </nav>
          <a
            href="tel:+40744476911"
            className="rounded-xl bg-sky-600 px-4 py-2 text-sm font-medium text-white shadow-sm transition hover:bg-sky-700"
          >
            Sună: +40 744 476 911
          </a>
        </div>

        {/* Mobile hamburger */}
        <button
          type="button"
          className="inline-flex h-10 w-10 items-center justify-center rounded-lg border hover:bg-slate-50 md:hidden"
          aria-label={open ? "Închide meniul" : "Deschide meniul"}
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
        >
          {open ? (
            <svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true">
              <path d="M6 6l12 12M6 18L18 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            </svg>
          ) : (
            <svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true">
              <path d="M3 6h18M3 12h18M3 18h18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            </svg>
          )}
        </button>
      </div>

      {/* Mobile dropdown */}
      {open && (
        <div className="md:hidden border-t bg-white">
          <div className="mx-auto max-w-6xl px-4 py-3">
            <nav className="grid gap-2 text-sm">
              {NAV.map((item) => (
                <Link
                  key={item.label}
                  to={item.path}
                  onClick={handleNavClick(item)}
                  className="rounded-lg px-3 py-2 hover:bg-slate-50"
                >
                  {item.label}
                </Link>
              ))}
            </nav>
            <div className="mt-3">
              <a
                href="tel:+40744476911"
                onClick={() => setOpen(false)}
                className="block rounded-lg bg-sky-600 px-3 py-2 text-center text-sm font-medium text-white shadow-sm transition hover:bg-sky-700"
              >
                Sună: +40 744 476 911
              </a>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
